/* eslint-disable no-param-reassign */
import {
  FETCH_SIZE_BARGE_LOADING,
  FETCH_SIZE_BARGE_DONE,
  FETCH_SIZE_BARGE_ERROR,
  FETCH_SIZE_LCT_LOADING,
  FETCH_SIZE_LCT_DONE,
  FETCH_SIZE_LCT_ERROR,
  FETCH_COMMODITIES_LOADING,
  FETCH_COMMODITIES_DONE,
  FETCH_COMMODITIES_ERROR
} from './actions';

export default {
  [FETCH_SIZE_BARGE_LOADING](state) {
    state.isLoadingSizeBarge = true;
  },
  [FETCH_SIZE_BARGE_DONE](state, items) {
    state.sizeBarge = items;
    state.isLoadingSizeBarge = false;
  },
  [FETCH_SIZE_BARGE_ERROR](state, error) {
    state.errorSizeBarge = error;
    state.isLoadingSizeBarge = false;
  },

  [FETCH_SIZE_LCT_LOADING](state) {
    state.isLoadingSizeLCT = true;
  },
  [FETCH_SIZE_LCT_DONE](state, items) {
    state.sizeLCT = items;
    state.isLoadingSizeLCT = false;
  },
  [FETCH_SIZE_LCT_ERROR](state, error) {
    state.errorSizeLCT = error;
    state.isLoadingSizeLCT = false;
  },

  [FETCH_COMMODITIES_LOADING](state) {
    state.isLoadingDataCommodities = true;
  },
  [FETCH_COMMODITIES_DONE](state, items) {
    state.commodities = items;
    state.isLoadingDataCommodities = false;
  },
  [FETCH_COMMODITIES_ERROR](state, error) {
    state.errorDataCommodities = error;
    state.isLoadingDataCommodities = false;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/vessel-charter/mutations.js